module.exports = __webpack_public_path__ + "static/media/Template_2.7631ce86.png";